const API_BASE_URL = 'https://api.frankfurter.dev/v2';

// Список нужных валют
export const CURRENCIES = [
  'USD', 'EUR', 'CNY', 'AED',
  'GBP', 'JPY', 'CAD', 'AUD', 'CHF', 'RUB', 'INR', 'BRL', 'KRW', 'TRY', 'ZAR'
];

// Fallback курсы (на основе реальных данных от 2026-03-24)
export const FALLBACK_RATES = {
  USD: 1,
  EUR: 0.86624,    // 1 USD = 0.86624 EUR
  CNY: 7.9752,     // 1 USD = 7.9752 CNY
  AED: 3.6725,     // 1 USD = 3.6725 AED
  GBP: 0.74757,    // 1 USD = 0.74757 GBP
  JPY: 159.32,     // 1 USD = 159.32 JPY
  CAD: 1.375,      // 1 USD = 1.375 CAD
  AUD: 1.432,      // 1 USD = 1.432 AUD
  CHF: 0.790,      // 1 USD = 0.790 CHF
  RUB: 82.15,      // 1 USD = 82.15 RUB
  INR: 93.75,      // 1 USD = 93.75 INR
  BRL: 5.275,      // 1 USD = 5.275 BRL
  KRW: 1497,       // 1 USD = 1497 KRW
  TRY: 44.40,      // 1 USD = 44.40 TRY
  ZAR: 16.97       // 1 USD = 16.97 ZAR
};

export const fetchExchangeRates = async () => {
  // Исключаем USD из списка quotes, так как это базовая валюта
  const quotesToFetch = CURRENCIES.filter(c => c !== 'USD').join(',');

  const url = `${API_BASE_URL}/rates?base=USD&quotes=${quotesToFetch}`;

  console.log('Fetching rates from:', url);

  try {
    const response = await fetch(url);

    if (!response.ok) {
      const errorText = await response.text();
      console.error('API Error Response:', errorText);
      throw new Error(`API returned ${response.status}`);
    }

    const data = await response.json();
    console.log('API Response:', data);

    // data - массив объектов: [{ date, base, quote, rate }, ...]
    const ratesObject = {};

    data.forEach(item => {
      if (item.quote && item.rate) {
        ratesObject[item.quote] = item.rate;
      }
    });

    // Добавляем USD
    ratesObject['USD'] = 1;

    // Проверяем полученные курсы
    const expectedQuotes = CURRENCIES.filter(c => c !== 'USD');
    const missingQuotes = expectedQuotes.filter(quote => !ratesObject[quote]);

    if (missingQuotes.length > 0) {
      console.warn('Missing quotes in response:', missingQuotes);
      // Для отсутствующих валют используем fallback значения
      missingQuotes.forEach(quote => {
        if (FALLBACK_RATES[quote]) {
          ratesObject[quote] = FALLBACK_RATES[quote];
          console.warn(`Using fallback rate for ${quote}: ${FALLBACK_RATES[quote]}`);
        }
      });
    }

    return {
      base: 'USD',
      rates: ratesObject,
      date: data[0]?.date || new Date().toISOString().split('T')[0],
      timestamp: Date.now()
    };
  } catch (error) {
    console.error('Error fetching rates:', error);
    throw error;
  }
};